import { useEffect, useState } from 'react';

export function useDelayedFlag(flag: boolean, delayMs = 200) {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (!flag) {
      setShouldShow(false);
      return;
    }

    const timer = setTimeout(() => setShouldShow(true), delayMs);
    return () => clearTimeout(timer);
  }, [flag, delayMs]);

  return flag && shouldShow;
}
